import { JsonServiceClient } from "@servicestack/client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as CreDtos from "../CRE.dtos";

export const peopleApi = {
    get: () => {
        var client = new JsonServiceClient("");
        var query = new CreDtos.GetPeople();
        const request = client.get(query);
        return Observable.from(request);
    },
    upsert: (person: CreDtos.People) => {
        var client = new JsonServiceClient("");
        var query = new CreDtos.PostPeople();
        query.people = person;
        const request = client.post(query);
        return Observable.from(request);
    }
};




// WEBPACK FOOTER //
// ./src/services/people.ts